import {  HostListener,Component, OnInit,ViewChild, ɵConsole } from '@angular/core';
import swal from 'sweetalert2'; 
import { SelectItem } from 'primeng/api';
import { AuthService } from 'src/app/services/auth.service';
import * as _ from 'underscore';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {MenuItem} from 'primeng/api';
import * as fs from 'file-saver';
import { Workbook } from 'exceljs';

import { TreeNode } from "primeng/api";

export interface NewTreeNode extends TreeNode {
  visible?: boolean;
  children?: NewTreeNode[];
}

@Component({
  selector: 'app-frmmultihabilidad',
  templateUrl: './frmmultihabilidad.component.html',
  styleUrls: ['./frmmultihabilidad.component.scss']
})
export class FrmmultihabilidadComponent implements OnInit {

  loading: boolean = false;
  bRegistro: boolean = false;
  bRegistroP: boolean = false;

  options: NewTreeNode[];

  selectedFile: TreeNode;
  items1: MenuItem[];
  items: MenuItem[];  
  activeItem:MenuItem;
  
  bInicia:boolean= true;

  est; selest;

  itmmat={
    id:0,
    id_ant:0,
    codigo:""
  }
  bndmnugral=true;
  oculta_menu(){
    console.log("-");
    if(this.bndmnugral==true){
      this.bndmnugral=false;
    }else{
      this.bndmnugral=true;
    }
    console.log(this.bndmnugral);
  }
  pue; selpue;
  est1; selest1;
  hab; selhab;

  pag; selpag;
  per; selper;


  public mul: any;
  public mul2: any;
  public mul3: any;
  public muly: any;
  public muly1: any;
  public mulyTot: any;
  public mulyTot1: any;
  public mulx: any;
  public mulx1: any;

  Vcompetencia;
  
  tab1=false;
  tab2=false;
  tab3=false;
  tab4=false;

  constructor(
    public authService: AuthService,
    public router: Router,
    private http: HttpClient,
  ) { }

  ngOnInit(): void {
    this.items1 = [
      {label: 'Abrir matriz', icon: 'pi pi-folder-open', command: (event) => this.openMat(this.selectedFile)},
      {label: 'Nueva matriz', icon: 'pi pi-plus', command: (event) => this.newMat(this.selectedFile)},        
      {label: 'Modificar nombre', icon: 'pi pi-pencil', command: (event) => this.copymat(this.selectedFile,"mod")},        
      {label: 'Copiar matriz', icon: 'pi pi-copy', command: (event) => this.copymat(this.selectedFile,"cpy")},        
      {label: 'Eliminar matriz', icon: 'pi pi-trash', command: (event) => this.copymat(this.selectedFile,"eli")},        
    ];

    this.ls_inicia();
    this.ls_matrices("");
  }

  ls_inicia(){
    this.items = [
      {label: 'SUPERVISOR'},
      {label: 'COLABORADOR'},        
      {label: 'REPORTE COLABORADOR'},   
      {label: 'REPORTE COMPETENCIA'},     
    ];
    this.activeItem =this.items[0];
    this.tab1 = true;
  }

  nodeSelect(eve){
    this.openMat(this.selectedFile)
  }

  org;
  nodes: any;  
  ls_matrices(sqry){        
    this.loading =  true;

    if (sqry == ""){
      sqry = " select" +
             " id,id_ant,nombre" +
             " from tblencmultihabilidad"+
             " where estado = 'A'" +
             " order by id_ant";

      this.selest = [];
      this.selest = null;
    }

    this.authService.ejecuta1(sqry)
    .then(
      data  => { 
        this.loading =  false;       
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);      
        if (res.length!=0){
          var _vec = [];
          _vec.push({ 
            id: 0, 
            id_ant: -1, 
            nombre: "MATRICES", 
          });    
          for(var i = 0; i < res.length;i++){
            _vec.push({ 
              id: res[i].id, 
              id_ant: res[i].id_ant, 
              nombre: res[i].nombre, 
            });                         
          }
          this.org = _vec

          for(let i=0;i<this.org.length;i++){
            if(this.org[i].id==0){

              this.nodes=[{
                label: this.org[i].nombre,
                data: this.org[i].id,
                children:this.get_nodes(this.org[i].id)
                }];
            }
          }

          this.options = this.nodes ;
          this.options = this.getValidTreeNodeItems(this.options);
        }
    },
    error => {
        this.loading =  false;
        swal.fire('Datos incorrectos', '', 'error');
    });
  }

  get_nodes(id){
    var child:any=[];
    for(var x=0;x<this.org.length;x++){
      if (this.org[x].id_ant==id){
        child.push({
          label: this.org[x].nombre,
          data: this.org[x].id,
          children:this.get_nodes(this.org[x].id)
        });
      }
        
    }
    return child;
  }

  getValidTreeNodeItems(treeNodes: NewTreeNode[]): NewTreeNode[] {
    const validItem = treeNodes.filter(i => i.visible !== false);

    validItem.forEach(i => {
      if (i.children) {
        i.children = this.getValidTreeNodeItems(i.children);
      }
    });
    return validItem;
  }


  winmat:boolean=false;
  ls_nuevaMat(){
    this.itmmat.id = 0;
    this.itmmat.codigo = "";
    this.winmat = true;
    
    this.filtropue = false;

    this.pue = null; this.selpue = null;    
  }
  filtropue;
  checkPue(eve){
    this.pue = null; this.selpue = null;    

    if (eve.checked){      
      this.ls_listadopuestos();
    }
  }
  ls_listadopuestos(){
    var sqry;
    sqry = " select id, nombre from tblpuesto order by nombre";
    this.loading =  true;

    this.authService.ejecuta1(sqry)
    .then(
      data  => {        
        this.loading =  false;                        
        this.pue = data;
    },
    error => {
        this.loading =  false;
        swal.fire('Datos incorrectos', '', 'error');
    });
  }
  ls_selpuesto(){
    this.selhab = null;
    var sqry;
    sqry = " select id,nombre from tblcompetencia" +
           " where id in (" +
                         " select idcompetencia from tblpuestocompetencia" +
                         " where idpuesto = " + this.selpue.id +                                            
                         ")" +
           " and estado = 'A'" +
           " order by nombre";
    this.loading =  true;
    this.authService.ejecuta1(sqry)
    .then(
      data  => {        
        this.loading =  false;                        
        this.hab = data;
    },
    error => {
        this.loading =  false;
        swal.fire('Datos incorrectos', '', 'error');
    });
  }
  cancelarMat(){
    this.winmat = false;
  }
  
  winabr= false;
  openMat(file: TreeNode) {
    if (file.data == 0){
      swal.fire("Seleccione una matriz", '', 'error');
      return;
    }
    this.bInicia = false;
    this.itmmat.id = file.data;
    this.itmmat.codigo = file.label;
    this.winabr = false;
    this.ls_llama("abr");    
  }

  newMat(file: TreeNode){
    this.itmmat.id_ant = file.data;
    this.ls_nuevaMat();
  }
  

  guardaredimat(){
    this.loading = true;          
    var sqry;
    sqry = " update tblencmultihabilidad set " +
           " nombre = '" + this.itmmat.codigo + "'" +
           " where id = " + this.itmmat.id;
    this.loading =  true;

    this.authService.ejecuta1(sqry)
    .then(
      data  => {        
        this.loading =  false;                                
        this.winedimat= false;   

        this.ls_matrices("");
    },
    error => {
        this.loading =  false;
        swal.fire('Datos incorrectos', '', 'error');
    });    
  }

  winedimat:boolean=false;
  copymat(file: TreeNode,tpo){
    if (file.data == 0){
      swal.fire("Seleccione una matriz", '', 'error');
      return;
    }
    this.itmmat.id = file.data;
    this.itmmat.codigo = file.label;
    this.winedimat = true;
    this.editpo = tpo;
  }

  copymat1(){
    this.loading = true;    
    var sqry;
    sqry = " call spins_tblencmultihabilidad ('" + 
            this.itmmat.codigo + "'," +
            this.itmmat.id + ")";

    this.authService.ejecuta(sqry).subscribe(
      data1 => {   
          this.loading = false;            
          var dat1 = JSON.stringify(data1);
          var res1 = JSON.parse(dat1);              
          
          this.bInicia = false;                    
          this.itmmat.id = res1[0][0].id;
          this.itmmat.codigo = this.itmmat.codigo;

          this.ls_llama("nvo");  
          this.ls_matrices("");
          this.bInicia = false;  
          this.winedimat = false; 
    },
    error => {
        this.loading =  false;
        swal.fire('Datos incorrectos', '', 'error');
    });
  }

  cancelaredimat(){
    this.winedimat= false;
  }
 
  eliminaredimat(){
    this.loading = true;          
    var sqry;
    sqry = " update tblencmultihabilidad set estado = 'C'" +
           " where id = " + this.itmmat.id;
    this.loading =  true;

    this.authService.ejecuta1(sqry)
    .then(
      data  => {        
        this.loading =  false;                                
        this.winedimat= false;   

        this.itmmat.id =0;
        this.itmmat.codigo ="";


        this.mul = null;
        this.muly = null;
        this.muly1 = null;
        this.mulyTot = null;
        this.mulyTot1 = null;
        this.mulx = null;
        this.mulx1 = null;
        this.Vcompetencia = null;

        this.pag = null;
        this.selpag = null;
        this.per = null;
        this.selper = null;
        this.est1 = null;
        this.selest1 = null;

        this.ls_matrices("");
    },
    error => {
        this.loading =  false;
        swal.fire('Datos incorrectos', '', 'error');
    });    
  }

  guardarMat(){
    if (this.filtropue == false){
      swal.fire('Seleccione si requiere la matriz por puesto', '', 'error');
      return;
    }
    var stpo = "";
    if (this.filtropue){
      if (this.selhab == null){
        swal.fire('Seleccione por lo menos una habilidad', '', 'error');
        return;
      }
      if (this.selhab.length == 0){
        swal.fire('Seleccione por lo menos una habilidad', '', 'error');
        return;
      } 
      stpo = "H";
    }
    var sopciones ="";
    for(var i = 0; i < this.selhab.length;i++){
      if (i>0){
        sopciones = sopciones + ",";
      }
      sopciones = sopciones +  this.selhab[i].id;           
    }
    var sqry;
    sqry = " call spinsupd_tblencmultihabilidad ('" +                                      
            this.itmmat.codigo + "','" +            
            sopciones + "'," +                        
            this.itmmat.id_ant + "," +
            this.itmmat.id + ")"


      this.authService.ejecuta1(sqry).then(
          data => {   
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat); 

            this.itmmat.id = res[0][0].id;

            this.winmat = false;            
            this.ls_llama("nvo");  
            this.ls_matrices("");
            this.bInicia = false;     
      },
      error => {
          this.loading =  false;
          swal.fire('Datos incorrectos', '', 'error');
      });
  }

  
  ls_llama(tpo){      
    this.loading = true;          
    var sqry;
    sqry = " select id, nombre from tblestacion where id in (" +
          " select idestacion from tbldetmultihabilidad" +
          " where idencmultihabilidad = " +  this.itmmat.id  + ")"
    this.loading =  true;

    this.authService.ejecuta1(sqry)
    .then(
      data2  => {                
        this.est1 = data2;
        var dat2 = JSON.stringify(data2);
        var res2 = JSON.parse(dat2); 

        switch (tpo) {
          case "edi":            
              this.selpag = {id: 1, nombre: 1};
              this.selper = {id: 0, nombre: "<Todos>"};
            break;          
          case "edipag":            
              this.selper = {id: 0, nombre: "<Todos>"};
            break;
          case "ediper":            
              this.selpag = {id: 1, nombre: 1};
            break;
          default:
              this.selest1 = {id: res2[0].id, nombre: res2[0].nombre};          
              this.selpag = {id: 1, nombre: 1};
              this.selper = {id: 0, nombre: "<Todos>"};
            break;
        }
        


        this.loading = true;          
        var sqry;
        sqry = " select" +
            " (count(*) / (select count(distinct(idcompetencia)) from tbldetmultihabilidad where idencmultihabilidad = " + this.itmmat.id + ")) as tot" +
            " from tbldetmultihabilidad" +
            " where idencmultihabilidad = " + this.itmmat.id +
            " and idestacion = " + this.selest1.id;

        this.loading =  true;

        this.authService.ejecuta1(sqry)
        .then(
          datan  => {        
            var datn = JSON.stringify(datan);
            var resn = JSON.parse(datn);      
            if (resn.length!=0){
              
              var _pag = [];      
              for (let i = 1; i <= ((resn[0].tot)/10)+1; i++) {
                _pag.push({ id: i, nombre: i });   
              }
              this.pag = _pag; 


              //XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
              
                    //-------------------------------
             sqry = " select" + 
                    " id," + 
                    " CONCAT(tblempleado.nombre,' ', tblempleado.apaterno,' ', tblempleado.amaterno) as nombre" +
                    " from tblempleado" + 
                    " where id in ( select idempleado from tbldetmultihabilidad" + 
                                  " where idencmultihabilidad = " + this.itmmat.id +
                                  " and idestacion = " + this.selest1.id +
                                  " )" + 
                    " order by nombre";

                this.authService.ejecuta1(sqry)
                .then(
                  datan1  => {        
                    var datn1 = JSON.stringify(datan1);
                    var resn1 = JSON.parse(datn1);      
                    if (resn1.length!=0){                      
                      var _per = [];      
                      _per.push({ id: 0, nombre: "<Todos>" });   
                      for (let j = 0; j < resn1.length; j++) {
                        _per.push({ id: resn1[j].id, nombre: resn1[j].nombre });   
                      }
                      this.per = _per;
                      //******************************

                      this.loading = true;    
                      this.authService.multihabilidades_N(this.itmmat.id, this.selest1.id, this.selpag.id, this.selper.id)
                      .then(
                          data => {
                            this.loading = false;            
                            var dat = JSON.stringify(data);
                            var res = JSON.parse(dat);              
                            if (res.length!=0)
                            {
                              //this.mul = data;    
                              
                              var _mul = [];            
                              for(var i = 0; i < res.length;i++){
                                _mul.push({ 
                                  id: res[i].id, 
                                  idempleado: res[i].idempleado,
                                  ficha: res[i].idempleado,
                                  nombre: res[i].nombre,
                                  codigo: res[i].codigo,
                                  codigo1: res[i].codigo1,
                                  imagen: res[i].codigo.toString() + '.jpeg',
                                  imagen1: res[i].codigo1.toString() + '.jpeg',
                                  competencia: res[i].competencia, 
                                  puesto : res[i].puesto,               
                                  supervisor : res[i].supervisor,               
                                  estacion : this.selest1.nombre,                                                 
                                });              
                              }
                              this.mul = _mul; 

                              var groups = _.groupBy(_mul, 'competencia');
                              var result = _.map(groups, function(value, key) {
                                return { 
                                  competencia: key, 
                                  codigo: _.reduce(value, function(total, o) { 
                                      return total + o.codigo;
                                  }, 0) 
                                };
                              });
                              //result = _.sortBy(result, 'competencia');                    
                              this.muly = result;


                              var resultA = _.map(groups, function(value, key) {
                                return { 
                                  competencia: key, 
                                  codigo1: _.reduce(value, function(total, o) { 
                                      return total + o.codigo1;
                                  }, 0) 
                                };
                              });
                              //resultA = _.sortBy(resultA, 'competencia');                    
                              this.muly1 = resultA; 


                              sqry = " select" +
                                    " sum(codigo) as codigo,tblcompetencia.nombre as competencia" +
                                    " from tbldetmultihabilidad,tblcompetencia" +
                                    " where idencmultihabilidad = " +  this.itmmat.id +
                                    " and idestacion = " +  this.selest1.id +
                                    " and tbldetmultihabilidad.idcompetencia = tblcompetencia.id" +
                                    " group by tblcompetencia.nombre" +
                                    " order by tblcompetencia.nombre";

                              this.authService.ejecuta1(sqry)
                              .then(
                                data3  => {        
                                  var dat3 = JSON.stringify(data3);
                                  var res3 = JSON.parse(dat3);      
                                  if (res3.length!=0){
                                    
                                    var _tot = [];      
                                    for (let i = 0; i < res3.length; i++) {
                                      _tot.push({ competencia: res3[i].competencia, codigo: res3[i].codigo });   
                                    }
                                    //_tot = _.sortBy(_tot, 'competencia');                    
                                    this.mulyTot = _tot; 
                                  }                    
                              },
                              error => {
                                  this.loading =  false;
                                  swal.fire('Datos incorrectos', '', 'error');
                              });


                              sqry = " select" +
                                    " sum(codigo1) as codigo,tblcompetencia.nombre as competencia" +
                                    " from tbldetmultihabilidad,tblcompetencia" +
                                    " where idencmultihabilidad = " +  this.itmmat.id +
                                    " and idestacion = " +  this.selest1.id +
                                    " and tbldetmultihabilidad.idcompetencia = tblcompetencia.id" +
                                    " group by tblcompetencia.nombre" +
                                    " order by tblcompetencia.nombre";

                              this.authService.ejecuta1(sqry)
                              .then(
                                data3  => {        
                                  var dat3 = JSON.stringify(data3);
                                  var res3 = JSON.parse(dat3);      
                                  if (res3.length!=0){
                                    
                                    var _tot = [];      
                                    for (let i = 0; i < res3.length; i++) {
                                      _tot.push({ competencia: res3[i].competencia, codigo: res3[i].codigo });   
                                    }
                                    this.mulyTot1 = _tot; 
                                  }                    
                              },
                              error => {
                                  this.loading =  false;
                                  swal.fire('Datos incorrectos', '', 'error');
                              });


                              groups = _.groupBy(_mul, 'nombre');
                              var result1 = _.map(groups, function(value:any, key) {
                                return { 
                                  nombre: key, 
                                  codigo: _.reduce(value, function(total, o) { 
                                      return total + o.codigo;
                                  }, 0),
                                  ficha: value[0].ficha,
                                  idempleado: value[0].idempleado,
                                  puesto: value[0].puesto,
                                  supervisor: value[0].supervisor,
                                  gerente: value[0].gerente,
                                  estacion: value[0].estacion,
                                  bahia: value[0].bahia,
                                  planta: value[0].planta,
                                };
                              });
                              result1 = _.sortBy(result1, 'nombre'); 
                              this.mulx = result1; 
                              
                              
                              groups = _.groupBy(_mul, 'nombre');
                              var result11 = _.map(groups, function(value:any, key) {
                                return { 
                                  nombre: key, 
                                  codigo1: _.reduce(value, function(total, o) { 
                                      return total + o.codigo1;
                                  }, 0),
                                  ficha: value[0].ficha,
                                  idempleado: value[0].idempleado,
                                  puesto: value[0].puesto,
                                  supervisor: value[0].supervisor,
                                  gerente: value[0].gerente,
                                  estacion: value[0].estacion,
                                  bahia: value[0].bahia,
                                  planta: value[0].planta,
                                };
                              });
                              result11 = _.sortBy(result11, 'nombre'); 
                              this.mulx1 = result11; 


                              var acompetencia = data.reduce( (a,b) => {
                                var i = a.findIndex( x => x.competencia === b.competencia);                    
                                return i === -1 ? a.push({ competencia : b.competencia}) : 0, a;
                              }, []);                                 
                              this.Vcompetencia = acompetencia;



                              

                              if (this.tab3){
                                this.ls_Reporte(1);      
                              }else{
                                if (this.tab4){
                                  this.ls_Reporte(2);      
                                }
                              }
                              
                              

                            }
                            else
                            {            
                              swal.fire('No existe información!', '', 'info');            
                            }
                          },
                          error => {
                              this.loading = false;
                              var de= JSON.stringify(error);
                              var di = JSON.parse(de)
                              swal.fire('¡Información incorrecta!', '', 'error');
                          });
                      


                      //******************************



                    }
                    this.loading =  false;                                
                },
                error => {
                    this.loading =  false;                    
                    swal.fire('Datos incorrectos', '', 'error');
                });

//-------------------------------

                  
                
              //XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX



            }
            this.loading =  false;                                
        },
        error => {
            this.loading =  false;
            swal.fire('Datos incorrectos', '', 'error');
        });


    },
    error => {
        this.loading =  false;
        swal.fire('Datos incorrectos', '', 'error');
    });
    
  }

  media_cod1=0; media_cod=0; media_sum=0;
  desviacion_cod1=0; desviacion_cod=0; desviacion_sum=0;
  ls_Reporte(tpo){
    var scompetencias = "";   
    var ssupervisores = "-";   
    this.authService.multihabilidadesTotNN(this.itmmat.id, this.selest1.id,tpo) 
    .then(
        data => {
          this.loading = false;            
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            //this.mul = data;    
            
            if (tpo == 1){
              var _mul = [];     
              var _codigo1 = [];            
              var _codigo = [];            
              var _suma = [];            
              for(var i = 0; i < res.length;i++){
                _mul.push({ 
                  idempleado: res[i].idempleado,
                  ficha: res[i].ficha,
                  nombre: res[i].nombre,
                  codigo: res[i].codigo,
                  codigo1: res[i].codigo1,
                  puesto : res[i].puesto,
                  supervisor : res[i].supervisor
                });     
                
                _codigo1.push(res[i].codigo1)
                _codigo.push(res[i].codigo)
                _suma.push(res[i].codigo + res[i].codigo1)
              }
              this.mul2 = _mul; 

              let codigo1 = { array: _codigo1 } 
              let codigo = { array: _codigo } 
              let suma = { array: _suma } 


              this.authService.media(codigo1)
              .then(data1 => {

                this.authService.media(codigo)
                .then(data2 => {

                  this.authService.media(suma)
                  .then(data3 => {

                    this.authService.desviacion(codigo1)
                    .then(data11 => {

                      this.authService.desviacion(codigo)
                      .then(data22 => {

                        this.authService.desviacion(suma)
                        .then(data33 => {

                          this.media_cod1 = data1;
                          this.media_cod = data2;
                          this.media_sum = data3;

                          this.desviacion_cod1 = data11;
                          this.desviacion_cod = data22;
                          this.desviacion_sum = data33;

                          
                        });
                        
                      });
                      
                    });
                    
                  });
                  
                });
                
              });
              
            }else {
              var _mul = [];            
              var _codigo1 = [];            
              var _codigo = [];            
              var _suma = [];            
              for(var i = 0; i < res.length;i++){
                _mul.push({ 
                  competencia: res[i].competencia,
                  codigo: res[i].codigo,
                  codigo1: res[i].codigo1,                  
                });              

                _codigo1.push(res[i].codigo1)
                _codigo.push(res[i].codigo)
                _suma.push(res[i].codigo + res[i].codigo1)
              }
              this.mul3 = _mul; 

              let codigo1 = { array: _codigo1 } 
              let codigo = { array: _codigo } 
              let suma = { array: _suma } 


              this.authService.media(codigo1)
              .then(data1 => {

                this.authService.media(codigo)
                .then(data2 => {

                  this.authService.media(suma)
                  .then(data3 => {

                    this.authService.desviacion(codigo1)
                    .then(data11 => {

                      this.authService.desviacion(codigo)
                      .then(data22 => {

                        this.authService.desviacion(suma)
                        .then(data33 => {

                          this.media_cod1 = data1;
                          this.media_cod = data2;
                          this.media_sum = data3;

                          this.desviacion_cod1 = data11;
                          this.desviacion_cod = data22;
                          this.desviacion_sum = data33;

                          
                        });
                        
                      });
                      
                    });
                    
                  });
                  
                });
                
              });

              

            }

            
          }
          else
          {            
            swal.fire('No existe información!', '', 'info');            
          }
        },
        error => {
            this.loading = false;
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡Información incorrecta!', '', 'error');
        });
  }

  ls_selestacion(){
    this.ls_llama("edi");
  }
  ls_selpagina(){
    this.ls_llama("edipag");
  }
  ls_selpersona(){
    this.ls_llama("ediper");
  }
  closeMat(){
    this.bInicia = true;
  }

  ls_paginas(tpo){
    this.loading = true;          
    var sqry;
    sqry = " select" +
        " (count(*) / (select count(distinct(idcompetencia)) from tbldetmultihabilidad where idencmultihabilidad = " + this.itmmat.id + ")) as tot" +
        " from tbldetmultihabilidad" +
        " where idencmultihabilidad = " + this.itmmat.id +
        " and idestacion = " + this.selest1.id;

    this.loading =  true;

    this.authService.ejecuta1(sqry)
    .then(
      data  => {        
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);      
        if (res.length!=0){
          
          var _pag = [];      
          for (let i = 1; i <= ((res[0].tot)/10)+1; i++) {
            _pag.push({ id: i, nombre: i });   
          }
          this.pag = _pag; 
        }
        this.loading =  false;                                
    },
    error => {
        this.loading =  false;
        swal.fire('Datos incorrectos', '', 'error');
    });
  }

  activateMenu(tab){
    this.tab1 = false;
    this.tab2 = false;    
    this.tab3 = false;    
    this.tab4 = false;    
    switch (tab.activeItem.label) {
      case "SUPERVISOR":
        this.tab1 = true;
        this.activeItem =this.items[1];this.activeItem =this.items[0];
        break;  
      case "COLABORADOR":
        this.tab2 = true;
        this.activeItem =this.items[0];this.activeItem =this.items[1];
        break;       
      case "REPORTE COLABORADOR":
        this.tab3 = true;
        this.activeItem =this.items[0];this.activeItem =this.items[2];
        this.ls_Reporte(1);
        break;
      case "REPORTE COMPETENCIA":
        this.tab4 = true;
        this.activeItem =this.items[0];this.activeItem =this.items[3];
        this.ls_Reporte(2);
        break;
        
    }
  }
  
  id_edi;
  codigo_edi;
  ls_cambia(itm){    
    if (this.tab1){
      this.id_edi = itm.id;
      this.codigo_edi = itm.codigo;

      this.wincod = true;
    }else{
      this.id_edi = itm.id;
      this.codigo_edi = itm.codigo1;

      this.wincod = true;
    }
  }
  wincod = false;
  cancela(){
    this.wincod = false;
  }
  ls_selcode(){
    var sqry;

    if (this.bRegistro == true){
      sqry = " update tbldetmultihabilidad set" +
             " codigo1 = " +  this.codigo_edi  +  
             " where id = " + this.id_edi;
    }else{
      if (this.tab1){
         sqry = " update tbldetmultihabilidad set" +
                " codigo = " +  this.codigo_edi  +  
                " where id = " + this.id_edi;
      }else{
        sqry = " update tbldetmultihabilidad set" +
                " codigo1 = " +  this.codigo_edi  +  
                " where id = " + this.id_edi;
      }
    }

    


    this.loading =  true;

    this.authService.ejecuta(sqry).subscribe(
        res => {        
        this.loading =  false;                        
        
        this.wincod = false;
        if (this.bRegistro == true){
          //this.ls_multihabilidades1(this.clave);
        }else{          
          this.ls_llama("edi");
        }
    },
    error => {
        this.loading =  false;
        swal.fire('Datos incorrectos', '', 'error');
    });
  }
  itmE = {    
    ficha: "",
    nombre: "",
  }
  winedi = false;  
  public edi: any;
  public editpo;
  ls_edita(itm,tpo){    
    this.winedi = true;
    this.itmE.ficha = itm.ficha;
    this.itmE.nombre = itm.nombre;
    this.editpo = tpo;

    var _edi = [];   
    for(var i = 0; i < this.mul.length;i++){
      if (this.mul[i].idempleado == itm.idempleado ){        
        _edi.push({ 
          id: this.mul[i].id, 
          ficha: this.mul[i].ficha,
          nombre: this.mul[i].nombre,
          codigo: this.mul[i].codigo,
          codigo1: this.mul[i].codigo1,          
          competencia: this.mul[i].competencia,          
        }); 
      }
    }
    this.edi = _edi;
  }

  cancelarEdi(){
    this.winedi = false;
  }
  guardarEdi(){
    this.loading =  true;
    this.authService.update_tblmultihabilidadN(this.edi)
    .then(
      data => {                 
        this.loading =  false;                
        swal.fire({ icon: "success", title: "Información registrada", showConfirmButton: false, timer: 1000 });
        this.ls_llama("edi");
        this.winedi = false;
    },
    error => {
        this.loading =  false;
        swal.fire({ icon: "success", title: "Información registrada", showConfirmButton: false, timer: 1000 });
        this.ls_llama("edi");
        this.winedi = false;
    });

  }

    
  exportExcelCol(){
    const workbook = new Workbook();    
    const worksheet = workbook.addWorksheet("COLABORADOR");
    const header = [];
    header.push("FICHA");
    header.push("NOMBRE");
    header.push("PUESTO");
    header.push("SUPERVISOR");
    header.push("COLABORADOR");
    header.push("SUPERVISOR");
    header.push("TOTAL");
    const headerRow = worksheet.addRow(header);
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'CCCCCCCC' },
        bgColor: { argb: 'CCCCCCCC' }
      };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });

    var exporta = this.mul2;
    var _exp = []   
    
    var k=1;
    for (let i = 0; i < exporta.length; i++) {
      const headerA = [];
      headerA.push(exporta[i].ficha);
      headerA.push(exporta[i].nombre);
      headerA.push(exporta[i].puesto);
      headerA.push(exporta[i].supervisor);
      headerA.push(exporta[i].codigo1);
      headerA.push(exporta[i].codigo);
      headerA.push(exporta[i].codigo1 + exporta[i].codigo);
      const headerRowA = worksheet.addRow(headerA);

      headerRowA.eachCell((cell, number) => {
        var color = "";

        if (number == 5 || number == 6 || number == 7 ){
          switch (number) {
            case 5:
                if (cell.value >= (this.media_cod1 + this.desviacion_cod1)){
                  color = 'c6efce';
                }else if (cell.value <= (this.media_cod1 - this.desviacion_cod1)){
                  color = 'ffc7ce';
                }else
                  color = 'ffffff';
              break;  
            case 6:
              if (cell.value >= (this.media_cod + this.desviacion_cod)){
                  color = 'c6efce';
                }else if (cell.value <= (this.media_cod - this.desviacion_cod)){
                  color = 'ffc7ce';
                }else
                  color = 'ffffff';
              break;  
            case 7:
              if (cell.value >= (this.media_sum + this.desviacion_sum)){
                  color = 'c6efce';
                }else if (cell.value <= (this.media_sum - this.desviacion_sum)){
                  color = 'ffc7ce';
                }else
                  color = 'ffffff';
              break;  
          }
        }
        
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: color },
          bgColor: { argb: color }
        };
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      });

      k= k + 1;
    }


    const headerM1 = []; 
    headerM1.push("MEDIA"); headerM1.push(""); headerM1.push(""); headerM1.push("");
    headerM1.push(this.media_cod1);headerM1.push(this.media_cod);headerM1.push(this.media_sum);
    const headerRowM1 = worksheet.addRow(headerM1); 
    headerRowM1.eachCell((cell, number) => {
      cell.alignment = {horizontal: 'right' }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });
    k = k + 1;  
    worksheet.mergeCells('A'+k.toString()+':D'+k.toString());


    const headerD = []; 
    headerD.push("DESV. STD"); headerD.push(""); headerD.push(""); headerD.push("");
    headerD.push(this.desviacion_cod1);headerD.push(this.desviacion_cod);headerD.push(this.desviacion_sum);
    const headerRowD = worksheet.addRow(headerD); 
    headerRowD.eachCell((cell, number) => {
      cell.alignment = {horizontal: 'right' }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });
    k = k + 1;  
    worksheet.mergeCells('A'+k.toString()+':D'+k.toString());
    

   const headerN = []; 
   headerN.push("N+"); headerN.push(""); headerN.push(""); headerN.push("");
   headerN.push(this.media_cod1 + this.desviacion_cod1);headerN.push(this.media_cod + this.desviacion_cod);headerN.push(this.media_sum + this.desviacion_sum);
   const headerRowN = worksheet.addRow(headerN); 
   headerRowN.eachCell((cell, number) => {
     cell.alignment = {horizontal: 'right' }
     cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'c6efce' },
        bgColor: { argb: 'c6efce' }
      };
     cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
   });
   k = k + 1;  
   worksheet.mergeCells('A'+k.toString()+':D'+k.toString());


   const headerM = []; 
   headerM.push("N-"); headerM.push(""); headerM.push(""); headerM.push("");
   headerM.push(this.media_cod1 - this.desviacion_cod1);headerM.push(this.media_cod - this.desviacion_cod);headerM.push(this.media_sum - this.desviacion_sum);
   const headerRowM = worksheet.addRow(headerM); 
   headerRowM.eachCell((cell, number) => {
     cell.alignment = {horizontal: 'right' }
     cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'ffc7ce' },
        bgColor: { argb: 'ffc7ce' }
      };
     cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
   });
   k = k + 1;  
   worksheet.mergeCells('A'+k.toString()+':D'+k.toString());



    worksheet.getColumn(1).width = 12;
    for (let i = 2; i <= 7; i++) {
      worksheet.getColumn(i).width = 15;
    }

    
    workbook.xlsx.writeBuffer().then((data: any) => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'COLABORADOR.xlsx');
    });

  }

  
  exportExcelHab(){
    const workbook = new Workbook();    
    const worksheet = workbook.addWorksheet("COMPETENCIA");
    const header = [];
    header.push("COMPETENCIA");
    header.push("COLABORADOR");
    header.push("SUPERVISOR");
    header.push("TOTAL");
    const headerRow = worksheet.addRow(header);
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'CCCCCCCC' },
        bgColor: { argb: 'CCCCCCCC' }
      };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });

    var exporta = this.mul3;
    var _exp = []   
    
    var k=1;
    for (let i = 0; i < exporta.length; i++) {
      const headerA = [];
      headerA.push(exporta[i].competencia);
      headerA.push(exporta[i].codigo1);
      headerA.push(exporta[i].codigo);
      headerA.push(exporta[i].codigo1 + exporta[i].codigo);
      const headerRowA = worksheet.addRow(headerA);

      headerRowA.eachCell((cell, number) => {
        var color = "";

        if (number == 2 || number == 3 || number == 4 ){
          switch (number) {
            case 2:
                if (cell.value >= (this.media_cod1 + this.desviacion_cod1)){
                  color = 'c6efce';
                }else if (cell.value <= (this.media_cod1 - this.desviacion_cod1)){
                  color = 'ffc7ce';
                }else
                  color = 'ffffff';
              break;  
            case 3:
              if (cell.value >= (this.media_cod + this.desviacion_cod)){
                  color = 'c6efce';
                }else if (cell.value <= (this.media_cod - this.desviacion_cod)){
                  color = 'ffc7ce';
                }else
                  color = 'ffffff';
              break;  
            case 4:
              if (cell.value >= (this.media_sum + this.desviacion_sum)){
                  color = 'c6efce';
                }else if (cell.value <= (this.media_sum - this.desviacion_sum)){
                  color = 'ffc7ce';
                }else
                  color = 'ffffff';
              break;  
          }
        }
        
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: color },
          bgColor: { argb: color }
        };
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      });

      k= k + 1;
    }


    const headerM1 = []; 
    headerM1.push("MEDIA"); 
    headerM1.push(this.media_cod1);headerM1.push(this.media_cod);headerM1.push(this.media_sum);
    const headerRowM1 = worksheet.addRow(headerM1); 
    headerRowM1.eachCell((cell, number) => {
      cell.alignment = {horizontal: 'right' }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });
    k = k + 1;      


    const headerD = []; 
    headerD.push("DESV. STD"); 
    headerD.push(this.desviacion_cod1);headerD.push(this.desviacion_cod);headerD.push(this.desviacion_sum);
    const headerRowD = worksheet.addRow(headerD); 
    headerRowD.eachCell((cell, number) => {
      cell.alignment = {horizontal: 'right' }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });
    k = k + 1;  


   const headerN = []; 
   headerN.push("N+"); 
   headerN.push(this.media_cod1 + this.desviacion_cod1);headerN.push(this.media_cod + this.desviacion_cod);headerN.push(this.media_sum + this.desviacion_sum);
   const headerRowN = worksheet.addRow(headerN); 
   headerRowN.eachCell((cell, number) => {
     cell.alignment = {horizontal: 'right' }
     cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'c6efce' },
        bgColor: { argb: 'c6efce' }
      };
     cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
   });
   k = k + 1;  


   const headerM = []; 
   headerM.push("N-"); 
   headerM.push(this.media_cod1 - this.desviacion_cod1);headerM.push(this.media_cod - this.desviacion_cod);headerM.push(this.media_sum - this.desviacion_sum);
   const headerRowM = worksheet.addRow(headerM); 
   headerRowM.eachCell((cell, number) => {
     cell.alignment = {horizontal: 'right' }
     cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'ffc7ce' },
        bgColor: { argb: 'ffc7ce' }
      };
     cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
   });
   k = k + 1;  


    worksheet.getColumn(1).width = 20;
    for (let i = 2; i <= 4; i++) {
      worksheet.getColumn(i).width = 15;
    }

    
    workbook.xlsx.writeBuffer().then((data: any) => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'COMPETENCIA.xlsx');
    });

  }

  exportExcel(){
    if (this.tab1){
      this.exportExcelA();
    }
    else{
      this.exportExcelB();
    }
  }

  exportExcelA(){
    var sqry = "";
    this.loading = true;    
    this.authService.multihabilidades_N(this.itmmat.id, this.selest1.id, 0, 0)
    .then(
        data => {
          this.loading = false;            
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            var _mul = [];            
            for(var i = 0; i < res.length;i++){
              _mul.push({ 
                id: res[i].id,                 
                ficha: res[i].idempleado,
                nombre: res[i].nombre,
                codigo: res[i].codigo,
                codigo1: res[i].codigo1,
                imagen: res[i].codigo.toString() + '.jpeg',
                imagen1: res[i].codigo1.toString() + '.jpeg',
                competencia: res[i].competencia, 
                puesto : res[i].puesto,               
                estacion : this.selest1.nombre,               
                supervisor: res[i].supervisor,   
              });              
            }


            var groups = _.groupBy(_mul, 'competencia');
            var result = _.map(groups, function(value, key) {
              return { 
                competencia: key, 
                codigo: _.reduce(value, function(total, o) { 
                    return total + o.codigo;
                }, 0) 
              };
            });
            //result = _.sortBy(result, 'competencia');                    
            
            var _muly: any;            
            _muly = result;

            sqry = " select" +
                  " sum(codigo) as codigo,tblcompetencia.nombre as competencia" +
                  " from tbldetmultihabilidad,tblcompetencia" +
                  " where idencmultihabilidad = " +  this.itmmat.id +
                  " and idestacion = " +  this.selest1.id +
                  " and tbldetmultihabilidad.idcompetencia = tblcompetencia.id" +
                  " group by tblcompetencia.nombre" +
                  " order by tblcompetencia.nombre";

            this.authService.ejecuta1(sqry)
            .then(
              data3  => {        
                var dat3 = JSON.stringify(data3);
                var res3 = JSON.parse(dat3);      
                if (res3.length!=0){
                  
                  var _tot = [];      
                  for (let i = 0; i < res3.length; i++) {
                    _tot.push({ competencia: res3[i].competencia, codigo: res3[i].codigo });   
                  }
                  //_tot = _.sortBy(_tot, 'competencia');                    
                  this.mulyTot = _tot; 
                }                    
            },
            error => {
                this.loading =  false;
                swal.fire('Datos incorrectos', '', 'error');
            });

            groups = _.groupBy(_mul, 'nombre');
            var result1 = _.map(groups, function(value:any, key) {
              return { 
                nombre: key, 
                codigo: _.reduce(value, function(total, o) { 
                    return total + o.codigo;
                }, 0),
                ficha: value[0].ficha,
                puesto: value[0].puesto,
                supervisor: value[0].supervisor,
                gerente: value[0].gerente,
                estacion: value[0].estacion,
                bahia: value[0].bahia,
                planta: value[0].planta,
              };
            });
            
            result1 = _.sortBy(result1, 'nombre'); 
            var _mulx: any;            
            _mulx = result1; 
            

            var acompetencia = data.reduce( (a,b) => {
              var i = a.findIndex( x => x.competencia === b.competencia);                    
              return i === -1 ? a.push({ competencia : b.competencia}) : 0, a;
            }, []);   
            //acompetencia = _.sortBy(acompetencia, 'competencia');                    

            var _Vcompetencia: any;            
            _Vcompetencia = acompetencia;

            this.exportExcelA1(_mulx,_muly,_Vcompetencia,_mul);

          }
          else
          {            
            swal.fire('No existe información!', '', 'info');            
          }
        },
        error => {
            this.loading = false;
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡Información incorrecta!', '', 'error');
        });

  }

  exportExcelB(){
    var sqry = "";
    this.loading = true;    
    this.authService.multihabilidades_N(this.itmmat.id, this.selest1.id, 0, 0)
    .then(
        data => {
          this.loading = false;            
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            //this.mul = data;    
            
            var _mul = [];            
            for(var i = 0; i < res.length;i++){
              _mul.push({ 
                id: res[i].id, 
                ficha: res[i].idempleado,
                nombre: res[i].nombre,
                codigo: res[i].codigo,
                codigo1: res[i].codigo1,
                imagen: res[i].codigo.toString() + '.jpeg',
                imagen1: res[i].codigo1.toString() + '.jpeg',
                competencia: res[i].competencia, 
                puesto : res[i].puesto,               
                estacion : this.selest1.nombre,               
                supervisor: res[i].supervisor,   
              });              
            }


            var groups = _.groupBy(_mul, 'competencia');
            var result = _.map(groups, function(value, key) {
              return { 
                competencia: key, 
                codigo: _.reduce(value, function(total, o) { 
                    return total + o.codigo;
                }, 0) 
              };
            });
            //result = _.sortBy(result, 'competencia');                    
            
            var _muly: any;            
            _muly = result;
            sqry = " select" +
                  " sum(codigo1) as codigo1,tblcompetencia.nombre as competencia" +
                  " from tbldetmultihabilidad,tblcompetencia" +
                  " where idencmultihabilidad = " +  this.itmmat.id +
                  " and idestacion = " +  this.selest1.id +
                  " and tbldetmultihabilidad.idcompetencia = tblcompetencia.id" +
                  " group by tblcompetencia.nombre" +
                  " order by tblcompetencia.nombre";
            this.authService.ejecuta1(sqry)
            .then(
              data3  => {         
                var dat3 = JSON.stringify(data3);
                var res3 = JSON.parse(dat3);      
                if (res3.length!=0){
                  
                  var _tot = [];      
                  for (let i = 0; i < res3.length; i++) {
                    _tot.push({ competencia: res3[i].competencia, codigo1: res3[i].codigo1 });   
                  }
                  //_tot = _.sortBy(_tot, 'competencia');                    
                  this.mulyTot = _tot; 
                }                    
            },
            error => {
                this.loading =  false;
                swal.fire('Datos incorrectos', '', 'error');
            });

            groups = _.groupBy(_mul, 'nombre');
            var result1 = _.map(groups, function(value:any, key) {
              return { 
                nombre: key, 
                codigo1: _.reduce(value, function(total, o) { 
                    return total + o.codigo1;
                }, 0),
                ficha: value[0].ficha,
                puesto: value[0].puesto,
                supervisor: value[0].supervisor,
                gerente: value[0].gerente,
                estacion: value[0].estacion,
                bahia: value[0].bahia,
                planta: value[0].planta,
              };
            });
            
            result1 = _.sortBy(result1, 'nombre'); 
            var _mulx: any;            
            _mulx = result1; 
            

            var acompetencia = data.reduce( (a,b) => {
              var i = a.findIndex( x => x.competencia === b.competencia);                    
              return i === -1 ? a.push({ competencia : b.competencia}) : 0, a;
            }, []);   
            //acompetencia = _.sortBy(acompetencia, 'competencia');                    

            var _Vcompetencia: any;            
            _Vcompetencia = acompetencia;

            this.exportExcelB1(_mulx,_muly,_Vcompetencia,_mul);

          }
          else
          {            
            swal.fire('No existe información!', '', 'info');            
          }
        },
        error => {
            this.loading = false;
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡Información incorrecta!', '', 'error');
        });

  }

  exportExcelA1(_mulx,_muly,_Vcompetencia,_mul){
    _mulx = _.sortBy(_mulx, 'nombre'); 
    _mulx = _mulx; 

    const workbook = new Workbook();    
    const worksheet = workbook.addWorksheet("Multihabilidades");

    const header = [];
      header.push("FICHA");
      header.push("NOMBRE");
      header.push("PUESTO");
      header.push("SUPERVISOR");
      header.push("ESTACIÓN");
      for (let i = 0; i < _Vcompetencia.length; i++) {
        header.push(_Vcompetencia[i].competencia);           
      }
      header.push("TOTAL");                            
      const headerRow = worksheet.addRow(header);
      headerRow.eachCell((cell, number) => {        
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'CCCCCCCC' },
          bgColor: { argb: 'CCCCCCCC' }
        };
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      });

      var kk = 1;
      for (let i = 0; i < _mulx.length; i++) {
        const headerA1 = [];
        headerA1.push(_mulx[i].ficha);
        headerA1.push(_mulx[i].nombre);
        headerA1.push(_mulx[i].puesto);
        headerA1.push(_mulx[i].supervisor);
        headerA1.push(_mulx[i].estacion);
        for (let j = 0; j < _Vcompetencia.length; j++) {
          headerA1.push(0); 
        }

        for (let j = 0; j < _Vcompetencia.length; j++) {
          for (let k = 0; k < _mul.length; k++) {
            if ( _mul[k].nombre == _mulx[i].nombre && _mul[k].competencia == _Vcompetencia[j].competencia){
              headerA1[j+5] = _mul[k].codigo
            }            
          }
        }
        
        headerA1.push(_mulx[i].codigo);            

        const headerRowA = worksheet.addRow(headerA1);          

        headerRowA.eachCell((cell, number) => {        
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
          cell.alignment = { wrapText: true,  horizontal: 'center' , vertical:'middle'};
        });
        kk= kk+1;
      }

      
      const header1 = [];
      header1.push("TOTAL");
      header1.push("");
      header1.push("");
      header1.push("");
      header1.push("");
      for (let i = 0; i < _muly.length; i++) {
         header1.push(_muly[i].codigo);            
      }

      const headerRow1 = worksheet.addRow(header1);
      headerRow1.eachCell((cell, number) => {        
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      });
      worksheet.getCell( _mulx.length+2 ,1).alignment = { horizontal: 'right'};                        
      for (let i = 6; i <= _Vcompetencia.length+5; i++) {                
        worksheet.getCell( _mulx.length+2 ,i).alignment = { horizontal: 'center'};                        
      }
      kk = kk + 1;  
      worksheet.mergeCells('A'+kk.toString()+':E'+kk.toString());

      
      worksheet.getRow(1).height = 300;
      worksheet.getCell(1,1).alignment = { wrapText: true,  horizontal: 'center'};
      worksheet.getCell(1,2).alignment = { wrapText: true,  horizontal: 'center'};
      worksheet.getCell(1,3).alignment = { wrapText: true,  horizontal: 'center'};
      worksheet.getCell(1,4).alignment = { wrapText: true,  horizontal: 'center'};
      worksheet.getCell(1,5).alignment = { wrapText: true,  horizontal: 'center'};
      for (let i = 6; i <= _Vcompetencia.length+5; i++) {                
        worksheet.getCell(1,i).alignment = { textRotation: 90, wrapText: true,  horizontal: 'center'};
      }
      worksheet.getCell(1,1).alignment = { horizontal: 'center'};
      worksheet.getCell(1,_Vcompetencia.length+6).alignment = { horizontal: 'center'};

      worksheet.getColumn(2).width = 25;
      worksheet.getColumn(3).width = 15;
      worksheet.getColumn(4).width = 25;
      worksheet.getColumn(5).width = 20;
      
      
      for (let i = 2; i <= _mulx.length+1; i++) {        
        worksheet.getRow(i).height = 50;        
        worksheet.getCell(i,1).alignment = { wrapText: true,  horizontal: 'center' , vertical:'middle'};
      }
      

      var logo;
      var img0 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAAGYktHRAD/AP8A/6C9p5MAAABHSURBVFhH7c6hAcAwDMCwrP//vA30A5MAiZj6eX+z2Lldy2BlsDJYGawMVgYrg5XBymBlsDJYGawMVgYrg5XBymBlsDLYzHw+6gRMMyEM6gAAAABJRU5ErkJggg==";
      var img1 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAAGYktHRAD/AP8A/6C9p5MAAABiSURBVFhH7dfBCcAgFATR/em/ZxMhHYyBDcwDwZPM0Z0k6zm1Pglc68yTM5PrvdcykDKQMpAykDKQMpAykDKQqg/8xyY5tSG2vSPcJE0MpAykDKQMpAykDKQMpOoDy7/8yQ2JVQ5HQJplPQAAAABJRU5ErkJggg==";
      var img2 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAAGYktHRAD/AP8A/6C9p5MAAABcSURBVFhH7dcxCsAwDATBU/7/ZyVFfrA2XLEDBlVmS2mS7PdqXQncPfPlzOT551oGUgZSBlIGUgZSBlIGUgZS9YHeJIQ3yQkGUgZSBlIGUgZSBlIGUvWB5St/8gLBHQtHkpQapAAAAABJRU5ErkJggg==";
      var img3 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAAGYktHRAD/AP8A/6C9p5MAAABbSURBVFhH7dcxCsAwDATBU/7/Z9lFfrAJXLEDAldiQZUnyd6p9Uvg7jcrZybP+65lIGUgZSBlIGUgZSBlIGUgVR9Y/yfxxJSBlIGUgZSBlIGUgZSBlIFUeWByAHVUBkvFqaQIAAAAAElFTkSuQmCC";
      var img4 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAAGYktHRAD/AP8A/6C9p5MAAABKSURBVFhH7c6xDYBAAAOxwP47AwUbuPniLEVp79r2fDvW/f+xClQFqgJVgapAVaAqUBWoClQFqgJVgapAVaAqUBWoClQFqgLN9gIT9wFPUpWWagAAAABJRU5ErkJggg==";
      var img5 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAAGYktHRAD/AP8A/6C9p5MAAABiSURBVFhH7dihDcAwDAVRNyuUFmb/iQJDO0MbRVUXOPLBPWLJ6GTo4776U8HaN2P9Fzzn2IsUq2vP+AsaSBlIGUgZSBlIGUgZSBlIGUgZSBlIGUgZSBlIGUgZSBlI+eVnql4Y0QnS66aQBgAAAABJRU5ErkJggg==";

     
    for (let j = 6; j <= _Vcompetencia.length+5; j++) {
      for (let k = 2; k <= _mulx.length+1; k++) {
        var valor = worksheet.getCell(k,j).value;
        switch (valor){
          case 0:
            logo = workbook.addImage({ base64: img0, extension: 'png'});          
            break;
          case 1:
            logo = workbook.addImage({ base64: img1, extension: 'png'});          
            break;
          case 2:
            logo = workbook.addImage({ base64: img2, extension: 'png'});          
            break;
          case 3:
            logo = workbook.addImage({ base64: img3, extension: 'png'});          
            break;
          case 4:
            logo = workbook.addImage({ base64: img4, extension: 'png'});          
            break;
          case 5:
            logo = workbook.addImage({ base64: img5, extension: 'png'});          
            break;
        }
        worksheet.getCell(k,j).value = "";

        
        worksheet.addImage(logo, {
          tl: { col: (j-1)+0.2, row: (k-1)+0.6 },          
          ext: { width: 32, height: 32 }
        });
        
        
      }
    }
    

    /*
    workbook.xlsx.writeBuffer().then((data: any) => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'multihabilidades.xlsx');
    });
    */

    workbook.xlsx.writeBuffer().then((data: any) => {
        const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        
        const blobToBase64 = blob => {
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          return new Promise(resolve => {
            reader.onloadend = () => {
              resolve(reader.result);
            };
          });
        };
        blobToBase64(blob).then(res => {        
          var tmpDate = new Date();   
          var now = tmpDate.getTime();
          let dataArc: any = {                
            name: now,
            firma: res,                
          }

          this.authService.xlsx(dataArc).then(data1 => {
            fs.saveAs(data1, 'multihabilidades.xlsx');
          });
        });
      });


  }

  exportExcelB1(_mulx,_muly,_Vcompetencia,_mul){

    const workbook = new Workbook();    
    const worksheet = workbook.addWorksheet("Multihabilidades");

    const header = [];
      header.push("FICHA");
      header.push("NOMBRE");
      header.push("PUESTO");
      header.push("SUPERVISOR");
      header.push("ESTACIÓN");
      for (let i = 0; i < _Vcompetencia.length; i++) {
        header.push(_Vcompetencia[i].competencia);           
      }
      header.push("TOTAL");                            
      const headerRow = worksheet.addRow(header);
      headerRow.eachCell((cell, number) => {        
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'CCCCCCCC' },
          bgColor: { argb: 'CCCCCCCC' }
        };
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      });

      var kk = 1;
      for (let i = 0; i < _mulx.length; i++) {
        const headerA1 = [];
        headerA1.push(_mulx[i].ficha);
        headerA1.push(_mulx[i].nombre);
        headerA1.push(_mulx[i].puesto);
        headerA1.push(_mulx[i].supervisor);
        headerA1.push(_mulx[i].estacion);
        for (let j = 0; j < _Vcompetencia.length; j++) {
          headerA1.push(0); 
        }

        for (let j = 0; j < _Vcompetencia.length; j++) {
          for (let k = 0; k < _mul.length; k++) {
            if ( _mul[k].nombre == _mulx[i].nombre && _mul[k].competencia == _Vcompetencia[j].competencia){
              headerA1[j+5] = _mul[k].codigo1
            }            
          }
        }
        
        headerA1.push(_mulx[i].codigo1);            

        const headerRowA = worksheet.addRow(headerA1);          

        headerRowA.eachCell((cell, number) => {        
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
          cell.alignment = { wrapText: true,  horizontal: 'center' , vertical:'middle'};
        });
        kk= kk+1;
      }

      
      const header1 = [];
      header1.push("TOTAL");
      header1.push("");
      header1.push("");
      header1.push("");
      header1.push("");
      for (let i = 0; i < _muly.length; i++) {
         header1.push(_muly[i].codigo1);            
      }

      const headerRow1 = worksheet.addRow(header1);
      headerRow1.eachCell((cell, number) => {        
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      });
      worksheet.getCell( _mulx.length+2 ,1).alignment = { horizontal: 'right'};                        
      for (let i = 6; i <= _Vcompetencia.length+5; i++) {                
        worksheet.getCell( _mulx.length+2 ,i).alignment = { horizontal: 'center'};                        
      }
      kk = kk + 1;  
      worksheet.mergeCells('A'+kk.toString()+':E'+kk.toString());

      
      worksheet.getRow(1).height = 300;
      worksheet.getCell(1,1).alignment = { wrapText: true,  horizontal: 'center'};
      worksheet.getCell(1,2).alignment = { wrapText: true,  horizontal: 'center'};
      worksheet.getCell(1,3).alignment = { wrapText: true,  horizontal: 'center'};
      worksheet.getCell(1,4).alignment = { wrapText: true,  horizontal: 'center'};
      worksheet.getCell(1,5).alignment = { wrapText: true,  horizontal: 'center'};
      for (let i = 6; i <= _Vcompetencia.length+5; i++) {                
        worksheet.getCell(1,i).alignment = { textRotation: 90, wrapText: true,  horizontal: 'center'};
      }
      worksheet.getCell(1,1).alignment = { horizontal: 'center'};
      worksheet.getCell(1,_Vcompetencia.length+6).alignment = { horizontal: 'center'};

      worksheet.getColumn(2).width = 25;
      worksheet.getColumn(3).width = 15;
      worksheet.getColumn(4).width = 25;
      worksheet.getColumn(5).width = 20;
      
      
      for (let i = 2; i <= _mulx.length+1; i++) {        
        worksheet.getRow(i).height = 50;        
        worksheet.getCell(i,1).alignment = { wrapText: true,  horizontal: 'center' , vertical:'middle'};
      }
      

      var logo;
      var img0 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAAGYktHRAD/AP8A/6C9p5MAAABHSURBVFhH7c6hAcAwDMCwrP//vA30A5MAiZj6eX+z2Lldy2BlsDJYGawMVgYrg5XBymBlsDJYGawMVgYrg5XBymBlsDLYzHw+6gRMMyEM6gAAAABJRU5ErkJggg==";
      var img1 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAAGYktHRAD/AP8A/6C9p5MAAABiSURBVFhH7dfBCcAgFATR/em/ZxMhHYyBDcwDwZPM0Z0k6zm1Pglc68yTM5PrvdcykDKQMpAykDKQMpAykDKQqg/8xyY5tSG2vSPcJE0MpAykDKQMpAykDKQMpOoDy7/8yQ2JVQ5HQJplPQAAAABJRU5ErkJggg==";
      var img2 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAAGYktHRAD/AP8A/6C9p5MAAABcSURBVFhH7dcxCsAwDATBU/7/ZyVFfrA2XLEDBlVmS2mS7PdqXQncPfPlzOT551oGUgZSBlIGUgZSBlIGUgZS9YHeJIQ3yQkGUgZSBlIGUgZSBlIGUvWB5St/8gLBHQtHkpQapAAAAABJRU5ErkJggg==";
      var img3 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAAGYktHRAD/AP8A/6C9p5MAAABbSURBVFhH7dcxCsAwDATBU/7/Z9lFfrAJXLEDAldiQZUnyd6p9Uvg7jcrZybP+65lIGUgZSBlIGUgZSBlIGUgVR9Y/yfxxJSBlIGUgZSBlIGUgZSBlIFUeWByAHVUBkvFqaQIAAAAAElFTkSuQmCC";
      var img4 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAAGYktHRAD/AP8A/6C9p5MAAABKSURBVFhH7c6xDYBAAAOxwP47AwUbuPniLEVp79r2fDvW/f+xClQFqgJVgapAVaAqUBWoClQFqgJVgapAVaAqUBWoClQFqgLN9gIT9wFPUpWWagAAAABJRU5ErkJggg==";
      var img5 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAAGYktHRAD/AP8A/6C9p5MAAABiSURBVFhH7dihDcAwDAVRNyuUFmb/iQJDO0MbRVUXOPLBPWLJ6GTo4776U8HaN2P9Fzzn2IsUq2vP+AsaSBlIGUgZSBlIGUgZSBlIGUgZSBlIGUgZSBlIGUgZSBlI+eVnql4Y0QnS66aQBgAAAABJRU5ErkJggg==";

     
    for (let j = 6; j <= _Vcompetencia.length+5; j++) {
      for (let k = 2; k <= _mulx.length+1; k++) {
        var valor = worksheet.getCell(k,j).value;
        switch (valor){
          case 0:
            logo = workbook.addImage({ base64: img0, extension: 'png'});          
            break;
          case 1:
            logo = workbook.addImage({ base64: img1, extension: 'png'});          
            break;
          case 2:
            logo = workbook.addImage({ base64: img2, extension: 'png'});          
            break;
          case 3:
            logo = workbook.addImage({ base64: img3, extension: 'png'});          
            break;
          case 4:
            logo = workbook.addImage({ base64: img4, extension: 'png'});          
            break;
          case 5:
            logo = workbook.addImage({ base64: img5, extension: 'png'});          
            break;
        }
        worksheet.getCell(k,j).value = "";

        
        worksheet.addImage(logo, {
          tl: { col: (j-1)+0.2, row: (k-1)+0.6 },          
          ext: { width: 32, height: 32 }
        });
        
        
      }
    }
    

    workbook.xlsx.writeBuffer().then((data: any) => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'multihabilidades.xlsx');
    });

  }

}
